module.exports = __webpack_public_path__ + "img/team_01.a8cad1fe.png";